import React from "react";

import SelectCell from "./SelectCell/SelectCell";
import EditableCellContainer from "./EditableCell/EditableCellContainer";

const CustomBodyCell = ({ children, ...rest }) => {
  const cell = rest.cell;
  const columnId = cell.column.id;

  if (columnId === "select") {
    return <SelectCell {...rest}>{children}</SelectCell>;
  };

  return <EditableCellContainer {...rest} >{children}</EditableCellContainer>
};

export default CustomBodyCell;
